import { WellnessCheckin as WellnessCheckinIcon } from "assets/icons";
import {
  DropdownSetting,
  InformationSetting,
  MultiLineSetting,
  RememberSettings,
  ToggleSetting,
} from "components/settings";
import { WidgetNames } from "constants/widgets";
import { WidgetType } from "types/Widget";
import { getSoundsArray } from "util/getSoundsArray";
import { LINE_LIMIT_CHECK_IN, TOTAL_LINE_LIMIT_CHECK_IN } from "util/widgeTransformData";

import HistorySetting from "./HistorySetting";
import { RegulationZoneSetting } from "./RegulationZoneSetting";
import { WellbeingCheck, WellbeingCheckState } from "./WellbeingCheck";
import { WellbeingCheckWordsList } from "./WellbeingCheckWordsList";

export const WellbeingCheckWidget: WidgetType<WellbeingCheckState> = {
  name: "Check-in",
  component: WellbeingCheck,
  icon: WellnessCheckinIcon,
  showOnToolbar: true,
  sizing: {
    minWidth: 277,
    minHeight: 277,
    minAspectRatio: 1,
    maxAspectRatio: 1,
  },
  defaultState: {
    droppedNames: {},
  },
  defaultSize: {
    aspectRatio: 1.25,
    widthPercentage: 35,
  },
  settings: {
    header: {
      editor: InformationSetting,
      info: {
        info: "Engage students in assessing their emotions and well-being with a simple and interactive check-in tool.",
      },
    },
    names: {
      editor: MultiLineSetting,
      info: {
        settingName: "Names List",
        lineLimit: LINE_LIMIT_CHECK_IN,
        totalLimit: TOTAL_LINE_LIMIT_CHECK_IN,
      },
      defaultValue: "Student 1\nStudent 2",
    },
    saveWords: {
      editor: WellbeingCheckWordsList,
      info: {
        settingName: "names",
      },
    },
    zones: {
      editor: RegulationZoneSetting,
      info: {},
    },
    history: {
      editor: HistorySetting,
      info: {
        label: "Show History",
      },
    },
    emojis: {
      editor: ToggleSetting,
      info: {
        label: "Show Emojis",
      },
      defaultValue: true,
    },
    sound: {
      editor: ToggleSetting,
      info: {
        label: "Sound Effects",
      },
      defaultValue: true,
    },
    selectSoundGreen: {
      editor: DropdownSetting,
      info: {
        name: "Select Green Sound",
        options: getSoundsArray(),
      },
      defaultValue: "yoo-hoo.mp3",
    },
    selectSoundBlue: {
      editor: DropdownSetting,
      info: {
        name: "Select Blue Sound",
        options: getSoundsArray(),
      },
      defaultValue: "yoo-hoo.mp3",
    },
    selectSoundYellow: {
      editor: DropdownSetting,
      info: {
        name: "Select Yellow Sound",
        options: getSoundsArray(),
      },
      defaultValue: "yoo-hoo.mp3",
    },
    selectSoundRed: {
      editor: DropdownSetting,
      info: {
        name: "Select Red Sound",
        options: getSoundsArray(),
      },
      defaultValue: "yoo-hoo.mp3",
    },
    rememberSettings: {
      editor: RememberSettings,
      info: {
        widgetName: WidgetNames.wellbeing,
        widgetDisplayName: "Check-in",
      },
    },
  },
  quickActions: {},
};
